module.exports = __webpack_public_path__ + "img/image-polaroid.eeae9234.svg";